import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalSessionRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.LOCAL_SESSIONS);
  }

  async getActiveByVesselId(vesselId) {
    return this.table
      .where("[vesselId+status]")
      .equals([vesselId, "active"])
      .first();
  }
}

